(function (angular, getComputedStyle, requestAnimationFrame, parseInt, gsap, Power0) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyRangePage", [
    "MouseDetectionService",
    function (MouseDetectionService) {
      var controller = [
          "$scope",
          "$element",
          function ($scope, $element) {
            var ctl = this;

            function init() {
              var $owlCarousel = $element.find(".owl-carousel");

              $owlCarousel.on("initialized.owl.carousel resized.owl.carousel", function (e) {
                $scope.page = e.page;
              });
            }

            ctl.$onInit = init;
          },
        ],
        link = function ($scope, $element) {
          var $owlCarousel = $element.find(".owl-carousel");
          var $owlStage = $element.find(".owl-stage");
          var $gradeCards = $element.find(".ty-range-page-grade");
          var progressErrorLimit = 0.01;

          $gradeCards.each(function (index, element) {
            var $el = angular.element(element);
            var gradeCardTimeline = gsap.timeline();
            gradeCardTimeline.pause();
            $el.data("owlItem", $el.closest(".owl-item"));
            $el.data("innerContainer", $el.find(".ty-range-page-grade__inner-container"));
            $el.data("gradeCardTimeline", gradeCardTimeline);

            /* eslint-disable no-magic-numbers */
            gradeCardTimeline.from($el, 0.2, {
              x: 0,
              y: 0,
              force3D: true,
              opacity: 0,
              ease: Power0.easeNone,
            });
            gradeCardTimeline.to(
              $el,
              0.2,
              {
                x: 0,
                y: 0,
                force3D: true,
                opacity: 0,
                ease: Power0.easeNone,
              },
              "0.8"
            );
            /* eslint-enable no-magic-numbers */

            $el.on("click", function () {
              if ($scope.page.size === 1 && $scope.page.index !== index) {
                $owlCarousel.trigger("to.owl.carousel", index);
              }
            });
          });

          function repaint() {
            var transformString = getComputedStyle($owlStage.get(0)).transform;
            var carouselScrollLeftStringMatch =
              transformString.match(/matrix\(.*,.*,.*,.*,(.*),.*\)/) ||
              transformString.match(/matrix3d\(.*,.*,.*,.*,.*,.*,.*,.*,.*,.*,.*,.*,(.*),.*,.*,.*\)/);
            var carouselScrollLeft = parseInt(carouselScrollLeftStringMatch ? carouselScrollLeftStringMatch[1] : 0, 10);

            $gradeCards.each(function (index, element) {
              var $gradeCard = angular.element(element);
              var $owlItem = $gradeCard.data("owlItem");
              var gradeCardTimeline = $gradeCard.data("gradeCardTimeline");
              var progressAmount = calculateCardProgress($owlItem, index, carouselScrollLeft);

              gradeCardTimeline.progress(progressAmount);
              $gradeCard.attr("progress", progressAmount);

              if (MouseDetectionService.mouseFound) {
                var $gradeCardInnerContainer = $gradeCard.data("innerContainer");
                $gradeCard.addClass("ty-range-page-grade__mouse-detected");

                if ($scope.page.size <= 1) {
                  $gradeCardInnerContainer.addClass("ty-range-page-grade__inner-container--fade-in");
                } else {
                  gradeCardFadeInOnDesktopCheck($gradeCardInnerContainer, progressAmount);
                }
              } else {
                $gradeCard.removeClass("ty-range-page-grade__mouse-detected");
              }
            });

            requestAnimationFrame(repaint);
          }

          /* eslint-disable no-magic-numbers */
          function calculateCardProgress($owlItem, owlItemIndex, carouselScrollLeft) {
            if ($scope.page.size <= 1) {
              // All cards will always show, 0.5 is an arbitrary progress number where opacity=1
              return 0.5;
            }

            var owlItemStyleAttrValue = $owlItem.attr("style");

            if (!owlItemStyleAttrValue) {
              return 0.5;
            }

            var owlItemWidthStyleMatch = $owlItem.attr("style").match(/width: ([.0-9]+)px/);
            var owlItemWidth = parseInt(owlItemWidthStyleMatch ? owlItemWidthStyleMatch[1] : 0, 10);
            var owlItemMarginStyleMatch = $owlItem.attr("style").match(/margin-right: ([0-9]+)px/);
            var owlItemMargin = parseInt(owlItemMarginStyleMatch ? owlItemMarginStyleMatch[1] : 0, 10);
            var owlItemTotalWidth = owlItemWidth + owlItemMargin;

            var position = owlItemIndex * owlItemTotalWidth + carouselScrollLeft;
            var totalWidth = owlItemTotalWidth * ($scope.page.size - 1);

            var progressAmount = Math.min(Math.max((position / totalWidth) * 0.6 + 0.2, 0), 1);

            if (progressAmount >= 0.8 && owlItemIndex < $scope.page.size) {
              progressAmount = 0.8;
            } else if (progressAmount <= 0.2 && owlItemIndex >= $gradeCards.length - $scope.page.size) {
              progressAmount = 0.2;
            }

            return progressAmount;
          }

          function gradeCardFadeInOnDesktopCheck($gradeCardInnerContainer, progressAmount) {
            if (progressAmount >= 0.2 - progressErrorLimit && progressAmount <= 0.8 + progressErrorLimit) {
              $gradeCardInnerContainer.addClass("ty-range-page-grade__inner-container--fade-in");
            } else if (progressAmount === 0 || progressAmount === 1) {
              $gradeCardInnerContainer.removeClass("ty-range-page-grade__inner-container--fade-in");
            }
          }
          /* eslint-enable no-magic-numbers */

          requestAnimationFrame(repaint);
        };

      return {
        scope: true,
        restrict: "A",
        controller: controller,
        controllerAs: "tyRangePage",
        link: link,
      };
    },
  ]);
})(window.angular, window.getComputedStyle, window.requestAnimationFrame, window.parseInt, window.gsap, window.Power0);
